/**
 * Creates a transition guard that prevents sync calls during
 * a debounce window after session transitions (start/end/pause/resume/reset).
 *
 * @param windowMs - debounce window in milliseconds (default 1000)
 */
export interface TransitionGuard {
  /** Record that a transition just happened. */
  markTransition: () => void;
  /** Timestamp of the last transition. */
  getLastTransitionAt: () => number;
  /** Returns true if we are still within the debounce window. */
  shouldDeferSync: (windowMs?: number) => boolean;
}

export function createTransitionGuard(defaultWindowMs = 1000): TransitionGuard {
  let lastTransitionAt = 0;

  return {
    markTransition: () => {
      lastTransitionAt = Date.now();
    },
    getLastTransitionAt: () => lastTransitionAt,
    shouldDeferSync: (windowMs?: number) => {
      return Date.now() - lastTransitionAt < (windowMs ?? defaultWindowMs);
    },
  };
}
